import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _values from "lodash/values";

var _templateObject;

import React from 'react';
import { gql } from '@nerdwallet/apollo';
import BaseMarketplaceStarRating, { LAYOUTS } from './base-marketplace-star-rating';

var GraphQlMarketplaceStarRating = function GraphQlMarketplaceStarRating(_ref) {
  var gqlMarketplaceEntity = _ref.marketplaceEntity,
      analytics = _ref.analytics,
      className = _ref.className,
      hideNumber = _ref.hideNumber,
      hideRatingText = _ref.hideRatingText,
      layout = _ref.layout,
      omitRatingTextHref = _ref.omitRatingTextHref,
      omitRatingNumberHref = _ref.omitRatingNumberHref,
      ratingTextHref = _ref.ratingTextHref,
      showNotYetRated = _ref.showNotYetRated,
      shouldDisplayInline = _ref.shouldDisplayInline,
      smallRatingText = _ref.smallRatingText,
      tooltipPlacement = _ref.tooltipPlacement,
      trkLocation = _ref.trkLocation,
      trkPageType = _ref.trkPageType,
      trkTaxonomy = _ref.trkTaxonomy;
  var reviewLink = gqlMarketplaceEntity.reviewLink,
      starRating = gqlMarketplaceEntity.starRating,
      starRatingTooltip = gqlMarketplaceEntity.starRatingTooltip;
  return /*#__PURE__*/React.createElement(BaseMarketplaceStarRating, {
    ratingTextTooltip: starRatingTooltip,
    ratingTextHref: ratingTextHref || reviewLink,
    shouldDisplayInline: shouldDisplayInline,
    analytics: analytics,
    className: className,
    hideNumber: hideNumber,
    hideRatingText: hideRatingText,
    layout: layout,
    gqlMarketplaceEntity: gqlMarketplaceEntity,
    omitRatingTextHref: omitRatingTextHref,
    omitRatingNumberHref: omitRatingNumberHref,
    showNotYetRated: showNotYetRated,
    smallRatingText: smallRatingText,
    starRating: starRating,
    tooltipPlacement: tooltipPlacement,
    trkLocation: trkLocation,
    trkPageType: trkPageType,
    trkTaxonomy: trkTaxonomy
  });
};

if (process.env.NODE_ENV !== 'production') {
  var PropTypes = require('prop-types'); // eslint-disable-line global-require


  GraphQlMarketplaceStarRating.propTypes = {
    /** (GraphQL) marketplace entity object */
    marketplaceEntity: PropTypes.shape({
      starRating: PropTypes.number,
      starRatingTooltip: PropTypes.string
    }),

    /** Subset of BaseMarketplaceStarRating.propTypes */

    /** An object specifying analytics details  */
    analytics: PropTypes.shape({
      entityName: PropTypes.string
    }),

    /** Optional classes to apply to the outer container. */
    className: PropTypes.string,

    /** Shows text and star rating inline. */
    shouldDisplayInline: PropTypes.bool,

    /** Hides the rating number */
    hideNumber: PropTypes.bool,

    /** Hides the rating text. */
    hideRatingText: PropTypes.bool,

    /** Specify alternate layouts from the enum list */
    layout: PropTypes.oneOf(_values(LAYOUTS)),

    /** If true, the link to the review on the rating text will be omitted. */
    omitRatingTextHref: PropTypes.bool,

    /** If true, the link to the review on the rating number will be omitted. */
    omitRatingNumberHref: PropTypes.bool,

    /** Href for the rating link. */
    ratingTextHref: PropTypes.string,

    /** Shows not yet rated component with empty star rating */
    showNotYetRated: PropTypes.bool,

    /** Gives both rating text and help bubble a font size of size-1 instead of the default size-2 */
    smallRatingText: PropTypes.bool,

    /** Help bubble tooltip placement */
    tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

    /** Tracking location (required if ratingTextHref is specified). */
    trkLocation: PropTypes.string,

    /** Tracking page type (required if ratingTextHref is specified). */
    trkPageType: PropTypes.string,

    /** Tracking taxonomy (required if ratingTextHref is specified). */
    trkTaxonomy: PropTypes.shape({
      /** Taxonomy page type. */
      pageType: PropTypes.string,

      /** Taxonomy topic. */
      topic: PropTypes.string,

      /** Taxonomy vertical. */
      vertical: PropTypes.string
    })
  };
}

GraphQlMarketplaceStarRating.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment MarketplaceStarRating on MarketplaceEntityInterface {\n    ... on MarketplaceEntityWithReviewInterface {\n      reviewLink\n    }\n    ... on MarketplaceEntityWithStarRatingInterface {\n      starRating\n      starRatingTooltip\n    }\n    ...BaseMarketplaceStarRating\n  }\n  ", "\n"])), BaseMarketplaceStarRating.fragment);
export default GraphQlMarketplaceStarRating;